<template>
  <div :class="classes()">
    <Container>
      <div :class="`${el}__inner ${el}__inner--withMargin`">
        <div :class="`${el}__row`">
          <Copy element="div" color="primaryBlue" bold>
            {{ $t('careLevelCalculator.start.topline') }}
          </Copy>
        </div>
        <Divider dotted />
        <Step1 v-if="step === 1" @onTrackingClick="trackClick" />
        <Step2 v-if="step === 2" />
      </div>
      <div v-if="step === 1" :class="`${el}__benefitsBullets`">
        <UnorderedList
          iconName="checkbox-circle-line"
          :listItems="$t('careLevelCalculator.landingPage.header.bulletpoints')"
          horizontal
          bold
        />
      </div>
    </Container>
  </div>
</template>

<script>
import Container from '@/objects/Container';
import Copy from '@/objects/Copy';
import Divider from '@/objects/Divider';
import UnorderedList from '@/objects/UnorderedList';

import { ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD } from '@/constants/routes';
import { SS_CARE_LEVEL_CALCULATOR_PREWIZARD_STEP2_RELOADED } from '@/constants/storage';

import { mapFieldsAuth, mapFieldsHealth } from '@/store/mapFields';

import Step1 from './subcomponents/Step1';
import Step2 from './subcomponents/Step2';
import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'CareLevelCalculatorPreWizard',
  props: {},
  components: {
    Copy,
    Divider,
    Container,
    Step1,
    Step2,
    UnorderedList,
  },
  computed: {
    ...mapFieldsAuth(['isAuthenticated']),
    ...mapFieldsHealth(['careLevelSituation', 'careLevel', 'dependentPerson']),

    hasCareLevel() {
      return this.careLevel !== null;
    },

    step() {
      let { step } = this.$route.params;
      return parseInt(step) || 1;
    },
  },
  data() {
    return {
      prevRoute: null,
      el: 'v-careLevelCalculatorPreWizard',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  mounted() {
    if (this.isAuthenticated) {
      /**
       * Im angemeldetem Zustand gibt es den PreWizard nicht,
       * daher Weiterleitung zum Wizard.
       */
      this.$router.push(ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD);
    }
    if (this.step !== 2) {
      sessionStorage.removeItem(SS_CARE_LEVEL_CALCULATOR_PREWIZARD_STEP2_RELOADED);
    }
  },

  methods: {
    trackClick(label, element = 'button', eventAction = '-click') {
      const product = 'Pflegegradrechner';
      const labelText = product + '-Start-Content-PG-' + label;

      createTrackingData(product, labelText, element, eventAction);
    },
  },
};
</script>
